import { api } from '@/portal-api.definition';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { usersQueryOptions } from './get-users.hook';
import { ActionType } from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useNosIdMutation({
    mutationFn: (userId: string) =>
      api.delete('/api/v1/users/secondary/:userId', { params: { userId } }),
    successLogAction: () => ({ ActionType: ActionType.DeleteSecondaryUser }),
    errorLogAction: () => ({ ActionType: ActionType.DeleteSecondaryUser }),
    onSuccess: (_result, userId) => {
      queryClient.setQueryData(usersQueryOptions.queryKey, (prev) =>
        (prev ?? []).filter((u) => u.Id !== userId),
      );
    },
  });
}
